import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5d3aa1a6&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=ts&"
export * from "./Main.vue?vue&type=script&lang=ts&"
import style0 from "./main.scss?vue&type=style&index=0&id=5d3aa1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3aa1a6",
  null
  
)

export default component.exports